import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { CARD_GAME_ROUTE, CATCH_GAME_ROUTE } from 'src/config/event/eventConfig';

const excludedPages = [
  'game/',
  'welcome-bonus',
  '404',
  'account',
  CATCH_GAME_ROUTE,
  CARD_GAME_ROUTE
];

export const useCheckGameBannerAvailable = () => {
  const { pathname } = useLocation();
  const isGameBannerAvailable = useMemo(
    () => !excludedPages.some((route) => pathname.includes(route)),
    [pathname]
  );
  return isGameBannerAvailable;
};
